import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import InventoryIcon from "@mui/icons-material/Inventory";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";

import Badge from "@/extensions/klarahill/components/Badge";
import { AdStatus } from "@/extensions/obituary/types";

import { statusLabels } from "../utils/statusLabels";

const statusIcon: Record<AdStatus, React.FC<{ fontSize: "small" }>> = {
  draft: CreateOutlinedIcon,
  customer_approved: ThumbUpAltIcon,
  pending_mediahouse_review: NewspaperIcon,
  sent: CheckIcon,
  rejected: ClearIcon,
  archived: InventoryIcon,
  cancelled: ClearIcon,
  pending_cancellation_review: NewspaperIcon,
};

const statusColor: Record<AdStatus, Readonly<[string, string]>> = {
  draft: ["#BBDEFB", "#1976D2"],
  customer_approved: ["#C8E6C9", "#1B5E20"],
  pending_mediahouse_review: ["#E5E5E5", "#525252"],
  sent: ["#C8E6C9", "#1B5E20"],
  rejected: ["#FFE0B2", "#E65100"],
  archived: ["#E0E0E0", "#424242"],
  cancelled: ["#FFCDD2", "#B71C1C"],
  pending_cancellation_review: ["#E5E5E5", "#525252"],
};

export interface GiftStatusBadgeProps {
  type: AdStatus;
}

const AdStatusBadge: React.FC<GiftStatusBadgeProps> = ({ type }) => {
  const [background, foreground] = statusColor[type];
  const label = statusLabels[type];
  const Icon = statusIcon[type];

  return (
    <Badge
      backgroundColor={background}
      foregroundColor={foreground}
      icon={<Icon fontSize="small" />}
      label={label}
      sx={{ flex: "none" }}
    />
  );
};

export default AdStatusBadge;
